import { render } from "./organizationManage.vue?vue&type=template&id=25822ff8"
import script from "./organizationManage.vue?vue&type=script&lang=js"
export * from "./organizationManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__